import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { auth, db } from "../firebase";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { FiEye, FiEyeOff } from "react-icons/fi";
import Swal from "sweetalert2";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 🔐 Login Firebase
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // 🔍 Ambil role dari Firestore
      const userSnap = await getDoc(doc(db, "users", user.uid));

      if (!userSnap.exists()) {
        Swal.fire(
          "Error",
          "Data akun tidak ditemukan di sistem.",
          "error"
        );
        setLoading(false);
        return;
      }

      const { role, nama } = userSnap.data();

      // 🧑‍🎓 SISWA
      if (role === "siswa") {
        localStorage.setItem("siswaLoggedIn", "true");
        localStorage.removeItem("adminLoggedIn");

        Swal.fire({
          icon: "success",
          title: "Login Berhasil",
          text: `Selamat datang, ${nama || "Siswa"} 🎓`,
          timer: 1500,
          showConfirmButton: false,
        });

        navigate("/siswa");
        return;
      }

      // 🧑‍💼 ADMIN
      if (role === "admin") {
        localStorage.setItem("adminLoggedIn", "true");
        localStorage.removeItem("siswaLoggedIn");

        Swal.fire({
          icon: "success",
          title: "Login Admin Berhasil",
          text: "Selamat datang di dashboard admin",
          timer: 1500,
          showConfirmButton: false,
        });

        navigate("/admin");
        return;
      }

      // ❌ ROLE TIDAK VALID
      Swal.fire(
        "Akses Ditolak",
        "Role akun tidak dikenali oleh sistem.",
        "error"
      );
    } catch (error) {
      let message = "Email atau password salah!";
      if (error.code === "auth/invalid-email")
        message = "Format email tidak valid!";
      if (error.code === "auth/user-disabled")
        message = "Akun ini dinonaktifkan!";
      if (error.code === "auth/user-not-found")
        message = "Email belum terdaftar!";

      Swal.fire("Login Gagal", message, "error");
    } finally {
      setLoading(false);
    }
  };

  // 🔁 RESET PASSWORD
  const handleForgotPassword = async () => {
    if (!email)
      return Swal.fire(
        "Peringatan",
        "Masukkan email terlebih dahulu!",
        "warning"
      );

    try {
      await sendPasswordResetEmail(auth, email);
      Swal.fire(
        "Berhasil",
        "Email reset password telah dikirim. Cek inbox atau spam.",
        "success"
      );
    } catch (error) {
      let message = error.message;
      if (error.code === "auth/user-not-found")
        message = "Email tidak terdaftar!";
      if (error.code === "auth/invalid-email")
        message = "Format email tidak valid!";
      Swal.fire("Error", message, "error");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "400px" }}>
      <h3 className="text-center mb-4 fw-bold text-primary">
        Login 
      </h3>

      <form onSubmit={handleLogin}>
        <div className="mb-3">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="email@gmail.com"
          />
        </div>

        <div className="mb-3">
          <label>Password</label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
            <span
              className="input-group-text"
              style={{ cursor: "pointer" }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-link p-0 mb-3"
          onClick={handleForgotPassword}
        >
          Lupa password?
        </button>

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={loading}
        >
          {loading ? "Memproses..." : "Login"}
        </button>
      </form>

      <p className="text-center mt-3">
        Belum punya akun siswa?{" "}
        <Link to="/daftar-akun" className="text-decoration-none fw-semibold">
          Daftar sekarang
        </Link>
      </p>
    </div>
  );
}
